import { Box, Button, useTheme, Fade } from "@mui/material";
import OutputField from "../resultsCard/resultscard";
import InputForm from "../inputForm/inputForm";
import SmartAssistant from "../smartAssistant/smartassistant";
import { useState } from "react";
import { Result, calculateAbsense } from "../utlis/computeRemaining";
import NewFeature from '../assets/icons/newfeature.png';
import NavBar from "../navbar/navbar";
import Cookies from "js-cookie";
import ReportBugNotification from "../notifications/reportBugNotification/reportBugNotification";
import NotificationModal from "../notificationModal/notificationModal";
import NewFeaturesNotification from "../notifications/newFeaturesNotification/newFeaturesNotification";
import ModeratorNotification from "../notifications/moderatorNotifiaction/moderatorNotifiaction";

interface IHomeProps {
  bylaw: string;
}

const Home: React.FC<IHomeProps> = (props: IHomeProps) => {
  const [ bylaw, setBylaw ] = useState<string>(Cookies.get('bylaw') ?? 'New');
  const [ result, setResult ] = useState<Result>({firstWarning:-1, secondWarning:-1, deprivedFlag:-1, type: 'normal', possibleCombinations:[]});
  const [ smartAssistant, setSmartAssitant ] = useState(true);
  const [ bugDialog, setBugDialog ] = useState(false);

  const handleBylawChange = () => {
    setBylaw(bylaw === 'New' ? 'Old' : 'New');
    Cookies.set('bylaw', bylaw === 'New' ? 'Old' : 'New');
    document.getElementById('clear-button')?.click()
  };
  const handleReportBug = () => setBugDialog(true);

  const theme = useTheme();
  
  return (
    <>
      <NavBar onBylawChange={handleBylawChange} onReportBug={handleReportBug} currentBylaw={bylaw}/>

      { 
        !smartAssistant &&
      <Box sx={{display: 'flex', flexDirection: 'column', '@media screen and (max-width: 768px)': { flex: 1 }}}>
        <Box sx={{
          display:'flex',
          maxWidth:'100%',
          minHeight: '475px',
          justifyContent: 'center',
          flexWrap: 'wrap', 
          gap:'10px 100px',
          '@media screen and (max-width: 768px)': { padding: '0px 10px', minHeight: 'auto' }
        }}>
          <Box 
            sx={{
              display: 'flex', 
              flexDirection: 'column',        
              '@media screen and (max-width: 768px)': { flex: 1 }
            }}>
            <Button
              id={'use-smart-assistant'} 
              onClick={() => setSmartAssitant(true)} 
              sx={{
                display: 'flex',
                justifyContent: 'left',
                fontSize: '20px',
                background: bylaw === 'Old' ? theme.palette.common.oldBylawColor : theme.palette.common.newBylawColor,
                marginBottom: '15px', 
                color: 'black',
                gap: '10px',
                ':hover': {
                  background: bylaw === 'Old' ? theme.palette.common.oldBylawHoverColor : theme.palette.common.newBylawHoverColor,
                }
              }}>
              <img src={NewFeature} width={35} height={35}/>
              Use Smart Assistant
            </Button>
            <InputForm 
              bylaw={bylaw} 
              onFormSubmit={(course)=> setResult(calculateAbsense(course.courseID, course.credits, course.missedLecs, course.missedTuts))}
              onFormClear={()=>setResult({firstWarning:-1, secondWarning:-1, deprivedFlag:-1, type: 'normal', possibleCombinations:[]})}
            />
          </Box>

          <OutputField data={result} bylaw={bylaw}/>
        </Box>
      </Box>
      }
      {
        smartAssistant &&
      <Box 
        sx={{
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          '@media screen and (max-width: 768px)': { width: 'auto'}    
        }}>
        <Button 
          onClick={() => setSmartAssitant(false)} 
          sx={{
            display: 'flex',
            justifyContent: 'center',
            fontSize: '20px',
            width: '300px',
            background: bylaw === 'Old' ? theme.palette.common.oldBylawColor : theme.palette.common.newBylawColor,
            marginBottom: '15px', 
            color: 'black',
            gap: '10px',
            ':hover': {
              background: bylaw === 'Old' ? theme.palette.common.oldBylawHoverColor : theme.palette.common.newBylawHoverColor,
            }
          }}>
          Back to Normal Calculator
        </Button>
        <SmartAssistant bylaw={bylaw} />
      </Box>
      }

      {/* {Cookies.get('moderator') !== 'no' && <ModeratorNotification onClick={() => {return}}/>} */}
      <NotificationModal closeModal={bugDialog}>
        <ReportBugNotification bylaw={bylaw} onClose={() => {setBugDialog(false);}} />
      </NotificationModal>
    </>
  )
}

export default Home;